export default {
  // Organism
  organism: "C. elegans",

  // Neurodynamics
  // an array of experiments
  neurodynamicsExperimentsArr: [
    {
      id: "neurodynamicsExp-1",
      displayNumber: 1,
      neurodynamicsCoverage: 50,
      recordingResolution: "brain-area",
      recordingSpeed: 1000,
      behavior: "moving",
      totalHours: 1,
      neuromodulatoryEffects: false,
    },
  ],
  // Initialize the counter. Since we start with Exp 1, the next one will be 2.
  neurodynamicsExpCounter: 2,

  // Connectomics
  // an array of experiments
  connectomicsExperimentsArr: [
    {
      id: "connectomicsExp-1",
      displayNumber: 1,
      connectomicsCoverage: 50,
      reconstructionResolution: "synapse",
      microscopyApproach: "expansion-microscopy",
      molecularAnnotation: false,
      numberOfMolecules: 10,
    },
  ],
  connectomicsExpCounter: 2,

  // Computational Neuroscience
  compNeuroBrainCoverage: "circuit",
  neuronalAccuracy: "neuronal-networks",
  simulationSpeed: 1000,
  speedFactor: -10,
  modulatoryFactors: [],

  // Projections
  techProgress: "linear",
  investment: 0,
  yearsToCompletion: 6,

  // Fetched data (from open data repo)
  // repoData: [],
};
